import { UmpireReportForAdminChartConfigDto, TableChartConfigDto } from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import TableChartSidebar from 'components/Table/TableChartSidebar';

const UmpirePerformanceSummaryChartSidebar = (props: ChartConfigProps<TableChartConfigDto, UmpireReportForAdminChartConfigDto>) => {
  return <TableChartSidebar chartId='UmpirePerformanceSummaryChart' chartKey='umpireReportPerformanceSummaryChartConfig' {...props} />;
};

export default UmpirePerformanceSummaryChartSidebar;
